// Port of api/fuel/app/classes/model/game/publisher.php
import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'game_publisher',
	prefix: '',
	key: 'game_publisher_id',
	fields: {
		game_publisher_id: Model.SCHEMA_NUMBER,
		game_id: Model.SCHEMA_NUMBER,
		game_version_id: Model.SCHEMA_NUMBER,
		publisher_id: Model.SCHEMA_NUMBER,
		game_publisher_primary: Model.SCHEMA_NUMBER
	}
})
